<script src="order-list.component.ts"></script>
<nz-card>
  <app-table-wrap>
    <ng-container content-selector="filterTableWrapTmpl">
      <div class="d-flex w-100">
        <nz-date-picker class="w-100 m-l-10 m-r-10" maskDate nzPlaceHolder="Từ ngày"
                        [(ngModel)]="filter.fromDate"
                        [nzDisabledDate]="disabledFromDate"
                        (ngModelChange)="filterChange($event)"></nz-date-picker>
        <nz-date-picker class="w-100 m-l-10 m-r-10" maskDate nzPlaceHolder="Đến ngày"
                        [nzDisabledDate]="disabledToDate"
                        [(ngModel)]="filter.toDate"
                        (ngModelChange)="filterChange($event)"></nz-date-picker>

      </div>

    </ng-container>

    <div>
      <div class="d-flex align-items-end justify-content-end m-b-10">
          <button nz-button nzType="primary" (click)="add()">
              <i-tabler name="plus" class="tb-icon tb-icon-m center"></i-tabler>
              Thêm mới
          </button>
          <button class="m-l-5" nz-button nzType="primary" (click)="doPrint()">
              <i-tabler name="printer" class="tb-icon tb-icon-m center"></i-tabler>
              In đơn
          </button>

      </div>
      <app-table [tableConfig]="tableConfig"
                 [tableData]="orderList"
                 [changeDetect]="tableConfig.loading"
                 (changePageNum)='getList()'
                 (doSort)="getList(false, $event)"
                 [checkedCashArrayFromComment]="selectedList"
      >
        <!--        Filter    -->
        <ng-template name="filter.customerName">
          <nz-input-group [nzPrefix]="suffixIconSearch">
            <input type="text" nz-input placeholder="Tên khách háng" [(ngModel)]="filter.customerName"
                   (ngModelChange)="filterChange($event)">
          </nz-input-group>
        </ng-template>
        <ng-template name="filter.address">
          <nz-input-group [nzPrefix]="suffixIconSearch">
            <input type="text" nz-input placeholder="Địa chỉ" [(ngModel)]="filter.address"
                   (ngModelChange)="filterChange($event)">
          </nz-input-group>
        </ng-template>
        <ng-template name="filter.phoneNumber">
          <nz-input-group [nzPrefix]="suffixIconSearch">
            <input type="text" nz-input placeholder="Số điện thoại" [(ngModel)]="filter.phoneNumber"
                   (ngModelChange)="filterChange($event)">
          </nz-input-group>
        </ng-template>
        <ng-template name="filter.product">
          <nz-input-group [nzPrefix]="suffixIconSearch">
            <input type="text" nz-input placeholder="Sản phẩm" [(ngModel)]="filter.product"
                   (ngModelChange)="filterChange($event)">
          </nz-input-group>
        </ng-template>
        <ng-template name="filter.channel">
          <nz-select style="width: 100%" [(ngModel)]="filter.channel" (ngModelChange)="filterChange($event)">
            <nz-option nzLabel="Tất cả" [nzValue]="null"></nz-option>
            <nz-option nzLabel="Trang cá nhân" [nzValue]="1"></nz-option>
            <nz-option nzLabel="Page" [nzValue]="2"></nz-option>
            <nz-option nzLabel="Khách lẻ" [nzValue]="3"></nz-option>

          </nz-select>
        </ng-template>
        <ng-template name="filter.paid">
          <nz-select style="width: 100%" [(ngModel)]="filter.paid" (ngModelChange)="filterChange($event)">
            <nz-option nzLabel="Tất cả" [nzValue]="null"></nz-option>
            <nz-option nzLabel="Đã thanh toán" [nzValue]="1"></nz-option>
            <nz-option nzLabel="Chưa thanh toán" [nzValue]="0"></nz-option>


          </nz-select>
        </ng-template>
        <ng-template name="filter.channelPayment">
          <nz-select style="width: 100%" [(ngModel)]="filter.channelPayment" (ngModelChange)="filterChange($event)">
            <nz-option nzLabel="Tất cả" [nzValue]="null"></nz-option>
            <nz-option nzLabel="Chuyển khoản" [nzValue]="1"></nz-option>
            <nz-option nzLabel="Ship thu" [nzValue]="2"></nz-option>
            <nz-option nzLabel="Tiền mặt" [nzValue]="3"></nz-option>

          </nz-select>
        </ng-template>
        <!--       -->
        <ng-template name="actionTmpl" let-data="data">
          <span [class]="(data.isPrint == null || data.isPrint == 0) ? 'order-not-printed' : 'order-printed'" style="display:none"></span>
          <a class="text-gray font-size-18" nz-dropdown nzPlacement="bottomCenter" nzTrigger="click"
             [nzDropdownMenu]="action">
            <i nz-icon nzType="ellipsis" theme="outline"></i>
          </a>
          <nz-dropdown-menu #action="nzDropdownMenu">
            <ul nz-menu nzSelectable>
              <li nz-menu-item (click)="edit(data)">
                <span>
                  <i nz-icon nzType="edit" theme="outline"></i>
                  <span class="m-l-10">Chỉnh sửa</span>
                </span>
              </li>

              <li nz-menu-divider></li>
              <li nz-menu-item (click)="delete(data)">
                <span>
                  <i nz-icon nzType="delete" theme="outline"></i>
                  <span class="m-l-10">Xóa</span>
                </span>
              </li>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="bookBe(data)">
                <span>
                  <i nz-icon nzType="car" nzTheme="outline"></i>
                  <span class="m-l-10">Đặt Be</span>
                </span>
              </li>
              <li nz-menu-divider></li>
              <li nz-menu-item (click)="printOrder(data)">
                <span>
                  <i nz-icon nzType="printer" nzTheme="outline"></i>
                  <span class="m-l-10">In đơn hàng</span>
                </span>
              </li>
            </ul>
          </nz-dropdown-menu>
        </ng-template>
        <ng-template name="paidTmpl" let-data="data">
          <nz-switch  class="{{data.paid == 1 ? 'paid-order' : 'not-paid-order' }}" style="padding-right: 4px"  [(ngModel)]="data.paid" (ngModelChange)="clickSwitchPaid(data)" [nzLoading]="isLoadingPaid"></nz-switch>
          <span>{{data.paid == 1 ? 'Đã tt' : 'Chưa tt' }}
           </span>
        </ng-template>
        <ng-template name="filter.isShipped">
          <nz-select style="width: 100%" [(ngModel)]="filter.isShipped" (ngModelChange)="filterChange($event)">
            <nz-option nzLabel="Tất cả" [nzValue]="null"></nz-option>
            <nz-option nzLabel="Đã giao" [nzValue]="1"></nz-option>
            <nz-option nzLabel="Chưa giao" [nzValue]="0"></nz-option>
          </nz-select>
        </ng-template>
        <ng-template name="shippedTmpl" let-data="data">
          <nz-switch style="padding-right: 4px" [(ngModel)]="data.isShipped" (ngModelChange)="clickSwitchShipped(data)" [nzLoading]="isLoadingShipped"></nz-switch>
          <span>{{data.isShipped == 1 ? 'Đã giao' : 'Chưa giao'}}</span>
        </ng-template>
        <!--  Custom Row      -->
      </app-table>
    </div>
  </app-table-wrap>
</nz-card>

<ng-template #suffixIconSearch>
  <span nz-icon nzType="search"></span>
</ng-template>
